/* Copy the SKU shown on product cards. Works for cards added later too. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-sku-copy]');
    if (!button) return;

    // The SKU sits inside the product link — don't open the product.
    event.preventDefault();
    event.stopPropagation();

    var sku = button.getAttribute('data-sku-copy') || '';
    if (!sku) return;

    function done() {
      button.classList.add('is--copied');
      setTimeout(function () {
        button.classList.remove('is--copied');
      }, 1500);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(sku).then(done).catch(function () {
        fallback(sku, done);
      });
    } else {
      fallback(sku, done);
    }
  });

  // Older browsers / pages not served over https.
  function fallback(text, done) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try { document.execCommand('copy'); done(); } catch (e) {}
    document.body.removeChild(field);
  }
})();
